import { barneyMediaArray } from './barneyMedia'
import { barneyBio } from './barneyBios'
import { tedProfileReviewHinge, tedProfileReviewBumble, robinProfileReviewTinder } from './barneyProfileReviews'

export const barneyDatingProfileHinge = {
  _id: 'barneyDatingProfileHingeId',
  userId: 'barneyUserId',
  email: 'barney@email.com',
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: barneyMediaArray[4]._id,
      mediaItemURL: barneyMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[4].type,
      caption: barneyMediaArray[4].captions[0],
      subcaption: barneyMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[11]._id,
      mediaItemURL: barneyMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[11].type,
      caption: barneyMediaArray[11].captions[0],
      subcaption: barneyMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[16]._id,
      mediaItemURL: barneyMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[16].type,
      caption: barneyMediaArray[16].captions[0],
      subcaption: barneyMediaArray[16].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[8]._id,
      mediaItemURL: barneyMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[8].type,
      caption: barneyMediaArray[8].captions[0],
      subcaption: barneyMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[19]._id,
      mediaItemURL: barneyMediaArray[19].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[19].type,
      caption: barneyMediaArray[19].captions[0],
      subcaption: barneyMediaArray[19].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[15]._id,
      mediaItemURL: barneyMediaArray[15].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[15].type,
      caption: barneyMediaArray[15].captions[0],
      subcaption: barneyMediaArray[15].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: barneyBio._id,
    vitalInfo: { ...barneyBio.vitalInfo },
    prompts: [
      { ...barneyBio.prompts[0] },
      { ...barneyBio.prompts[1] },
      { ...barneyBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: ['', '', '', '', ''],
  },
  profileReviews: [
    { ...tedProfileReviewHinge }
  ],
  mediaItems: [ ...barneyMediaArray ],
  bioItems: { ...barneyBio },
}

export const barneyDatingProfileBumble = {
  _id: 'barneyDatingProfileBumbleId',
  userId: 'barneyUserId',
  email: 'barney@email.com',
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: barneyMediaArray[4]._id,
      mediaItemURL: barneyMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[4].type,
      caption: barneyMediaArray[4].captions[0],
      subcaption: barneyMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[11]._id,
      mediaItemURL: barneyMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[11].type,
      caption: barneyMediaArray[11].captions[0],
      subcaption: barneyMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[16]._id,
      mediaItemURL: barneyMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[16].type,
      caption: barneyMediaArray[16].captions[0],
      subcaption: barneyMediaArray[16].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[8]._id,
      mediaItemURL: barneyMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[8].type,
      caption: barneyMediaArray[8].captions[0],
      subcaption: barneyMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[19]._id,
      mediaItemURL: barneyMediaArray[19].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[19].type,
      caption: barneyMediaArray[19].captions[0],
      subcaption: barneyMediaArray[19].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[15]._id,
      mediaItemURL: barneyMediaArray[15].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[15].type,
      caption: barneyMediaArray[15].captions[0],
      subcaption: barneyMediaArray[15].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: barneyBio._id,
    vitalInfo: { ...barneyBio.vitalInfo },
    prompts: [
      { ...barneyBio.prompts[0] },
      { ...barneyBio.prompts[1] },
      { ...barneyBio.prompts[2] }
    ],
    aboutMe: barneyBio.aboutMe[0],
    hobbies: [barneyBio.hobbies[0], barneyBio.hobbies[1], barneyBio.hobbies[2], barneyBio.hobbies[3], barneyBio.hobbies[4] ],
  },
  profileReviews: [
    { ...tedProfileReviewBumble }
  ],
  mediaItems: [ ...barneyMediaArray ],
  bioItems: { ...barneyBio },
}

export const barneyDatingProfileTinder = {
  _id: 'barneyDatingProfileTinderId',
  userId: 'barneyUserId',
  email: 'barney@email.com',
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: barneyMediaArray[4]._id,
      mediaItemURL: barneyMediaArray[4].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[4].type,
      caption: barneyMediaArray[4].captions[0],
      subcaption: barneyMediaArray[4].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[11]._id,
      mediaItemURL: barneyMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[11].type,
      caption: barneyMediaArray[11].captions[0],
      subcaption: barneyMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[16]._id,
      mediaItemURL: barneyMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[16].type,
      caption: barneyMediaArray[16].captions[0],
      subcaption: barneyMediaArray[16].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[8]._id,
      mediaItemURL: barneyMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[8].type,
      caption: barneyMediaArray[8].captions[0],
      subcaption: barneyMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[19]._id,
      mediaItemURL: barneyMediaArray[19].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[19].type,
      caption: barneyMediaArray[19].captions[0],
      subcaption: barneyMediaArray[19].subcaptions[0],
    },
    {
      mediaItemId: barneyMediaArray[15]._id,
      mediaItemURL: barneyMediaArray[15].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: barneyMediaArray[15].type,
      caption: barneyMediaArray[15].captions[0],
      subcaption: barneyMediaArray[15].subcaptions[0],
    }
  ],
  bio: {
    bioItemsId: barneyBio._id,
    vitalInfo: { ...barneyBio.vitalInfo },
    prompts: [
      { ...barneyBio.prompts[0] },
      { ...barneyBio.prompts[1] },
      { ...barneyBio.prompts[2] }
    ],
    aboutMe: barneyBio.aboutMe[0],
    hobbies: [barneyBio.hobbies[0], barneyBio.hobbies[1], barneyBio.hobbies[2], barneyBio.hobbies[3], barneyBio.hobbies[4] ],
  },
  profileReviews: [
    { ...robinProfileReviewTinder }
  ],
  mediaItems: [ ...barneyMediaArray ],
  bioItems: { ...barneyBio },
}